"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseButton = exports.TextButton = exports.TileButton = exports.FAB = exports.Link = exports.SecondaryCTAButton = exports.CTAButton = exports.SecondaryButton = exports.PrimaryButton = void 0;
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const Primary_1 = __importDefault(require("./Primary"));
const Secondary_1 = __importDefault(require("./Secondary"));
const CTA_1 = __importDefault(require("./CTA"));
const SecondaryCTA_1 = __importDefault(require("./CTA/SecondaryCTA"));
const Link_1 = __importDefault(require("./Link"));
const FAB_1 = __importDefault(require("./FAB"));
const TileButton_1 = __importDefault(require("./TileButton"));
const TextButton_1 = __importDefault(require("./TextButton"));
const BaseButton_1 = __importDefault(require("./BaseButton"));
exports.PrimaryButton = (0, common_buoy_theme_1.withTheme)(Primary_1.default);
exports.SecondaryButton = (0, common_buoy_theme_1.withTheme)(Secondary_1.default);
exports.CTAButton = (0, common_buoy_theme_1.withTheme)(CTA_1.default);
exports.SecondaryCTAButton = (0, common_buoy_theme_1.withTheme)(SecondaryCTA_1.default);
exports.Link = (0, common_buoy_theme_1.withTheme)(Link_1.default);
exports.FAB = (0, common_buoy_theme_1.withTheme)(FAB_1.default);
exports.TileButton = (0, common_buoy_theme_1.withTheme)(TileButton_1.default);
exports.TextButton = (0, common_buoy_theme_1.withTheme)(TextButton_1.default);
exports.BaseButton = (0, common_buoy_theme_1.withTheme)(BaseButton_1.default);
//# sourceMappingURL=index.js.map